import React, { useState, useEffect } from "react";
import { Box, Typography, styled } from "@mui/material";
import newLogo from "./newlogoeuropea.png";
import groupLogo from "./europea-residences-group.svg";
import convertImageToBase64 from "utils/convertImageToBase64";
import { shouldUseNewLogo } from "utils/shouldUseNewLogo";

// Styled component for the multi-layered border header
const MultiLayerBorderHeader = styled(Box)(({ theme }) => ({
  position: "relative",
  margin: theme.spacing(0, 0, 3, 0),
  padding: "2px", // Tiny padding for outermost border
  border: "3px solid #000",

  "& .inner-content": {
    padding: theme.spacing(1.5),
    border: "1px solid #000",
    textAlign: "center",
  },
}));

const HeaderTitle = styled(Typography)(() => ({
  fontWeight: 500,
}));

// Header component with multi-layered border
const EuropeaReceiptHeader = ({ title, displayTitle, logo, showLogo, month, year }) => {
  const [base64Image, setBase64Image] = useState("");

  useEffect(() => {
    if (!logo) return;

    // If already base64, set directly
    if (typeof logo === "string" && logo.startsWith("data:image")) {
      setBase64Image(logo);
      return;
    }

    // Otherwise convert URL to base64
    const loadImage = async () => {
      try {
        const base64 = await convertImageToBase64(logo);
        setBase64Image(base64);
      } catch (err) {
        console.error("Error converting logo:", err);
      }
    };

    loadImage();
  }, [logo]);

  // When the company has opted in (showLogo) and an uploaded logo is available,
  // use it; otherwise documents for September 2026 onwards use the Europea
  // Residences Group logo and earlier ones the default Europea logo.
  const displaySrc = showLogo && base64Image
    ? base64Image
    : (shouldUseNewLogo(month, year) ? groupLogo : newLogo);

  return (
    <>
      {displayTitle ? (
        <Box
          sx={{ mb: 3 }}
          alignContent={"start"}
          display={"flex"}
          justifyContent={"start"}
        >
          {displaySrc && (
            <img
              src={displaySrc}
              alt="logo"
              crossOrigin="anonymous"
              style={{
                width: "150px",
                height: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          )}
        </Box>
      ) : (
        <>
          <Box
            sx={{ mb: 2, mt: 0, pt: 0 }}
            alignContent={"center"}
            display={"flex"}
            justifyContent={"center"}
          >
            {displaySrc && (
              <img
                src={displaySrc}
                alt="logo"
                crossOrigin="anonymous"
                style={{ height: 61, width: "auto", maxWidth: 237, objectFit: "contain" }}
              />
            )}
          </Box>
          <MultiLayerBorderHeader>
            <Box className="inner-content">
              <HeaderTitle
                sx={{
                  fontSize: "1.15rem",
                  textTransform: "uppercase",
                  transform: "translateY(-7px)",
                }}
                variant="h6"
              >
                {title}
              </HeaderTitle>
            </Box>
          </MultiLayerBorderHeader>
        </>
      )}
    </>
  );
};

export default EuropeaReceiptHeader;
